import FlowsDataTable from "../../../components/dataTable/tables/FlowsDataTable";

function FlowsPageView() {
  return <FlowsDataTable />;
}

export default FlowsPageView;
